import { useState } from 'react';
import SearchBar from '../explore/searchBar/searchBar';
import {useTranslation} from "react-i18next";


const noop = () => {}

function formatSearchText(txt) {
  return txt.toUpperCase().replace('É', 'E');
}

function SelectPopup(props) {
  const {dataList, setOpen, category,
         contacts, setContacts, entities, setEntities,
         themes, setThemes, geo, setGeo} = props;

  const { t } = useTranslation();
  const [search, setSearch] = useState("");

  function searchBarChange(e) { setSearch(e.target.value); }
  function closePopup() { setOpen(false); }
  function validatePopup() { setOpen(false); }


  // apply search
  let data_list = dataList;

  const fmt_search = formatSearchText(search)

  if (search !== "") {
    if (category === "contact") {
      data_list = data_list.filter(c =>
        formatSearchText(c.firstname + " " + c.lastname).includes(fmt_search)
      );
    } else if (category === "entity") {
      data_list = data_list.filter(c =>
        formatSearchText(c.name).includes(fmt_search)
      );
    } else if (category === "theme") {
      data_list = data_list.filter(c =>
        formatSearchText(c.item).includes(fmt_search)
      );
    } else if(category === "geo") {
      data_list = data_list.filter(c =>
        formatSearchText(c.item).includes(fmt_search)
      );
    }
  }


  let inner_view;
  if (category === "theme") {
    inner_view = <ThemeItem theme={data_list} themes={themes} setThemes={setThemes} />
  } else if(category === "geo") {
    inner_view = <GeoItem geos={data_list} geo={geo} setGeo={setGeo} />
  } else if (category === "contact") {
    inner_view = data_list.map(c => (
      <ContactItem contact={c} setContacts={setContacts} contacts={contacts} key={c.id} />
    ))
  } else if (category === "entity") {
    inner_view = data_list.map(c => (
      <EntitieItem entity={c} setEntities={setEntities} entities={entities} key={c.id} />
    ))
  }

  return (
    <>
      <div className={`c-container_bg active`}>
        <div className="c-popup_bg_close" onClick={closePopup}></div>
        <div className="c-popup_div">
          <div className="c-popup_header">
            <span className="c-popup_close" onClick={closePopup}></span>
            <p>{t('Lier des')} {t(`${category}`)}</p>
            <button type="button" className="c-valid_button" onClick={validatePopup}>Valider</button>
          </div>
          <div className="c-popup_content">
            <div className="c-popup_searchbar">
              <SearchBar key={category} value={search}
                         handleChange={searchBarChange} autofocus={true} />
            </div>
            <div className="c-popup_search">
              { inner_view }
            </div>
          </div>
        </div>
      </div>
    </>
  )
}


function ContactItem({contact, contacts, setContacts}){
  const {id,img, firstname, lastname, extra_data} = contact;

  let span;
  let contact_img;

  if (extra_data.profession !== null && extra_data.full_mandat !== null) {
    span = <span>{extra_data.profession} | {extra_data.full_mandat}</span>
  }else if(extra_data.full_mandat === null){
    span = <span>{extra_data.profession}</span>
  }

  if(!img) {
    contact_img = <span className="c-contact_img-replace">{firstname[0].toUpperCase()}{lastname[0].toUpperCase()}</span>
  }else{
    contact_img = <img alt="" className="c-contact_img" style={{width: "50px", height: "50px"}} src={img} />
  }

  const checked = contacts.includes(contact.id);

  function toggle() {
    if (checked) {
      setContacts(contacts.filter(id => id !== contact.id));
    } else {
      setContacts([...contacts, contact.id]);
    }
  }

  return (
    <>
      <div className={`c-contact ${id}`} onClick={toggle}>
        <div className="c-contact_infos">
            {contact_img}
            <div className="c-infos">
              <p>{firstname} {lastname}</p>
              { span }
            </div>
        </div>
        <input type="checkbox" className="c-contact_checkbox" name="contacts" checked={checked} onChange={noop} />
      </div>
    </>
  )
}

const EntitieItem = ({entity, entities, setEntities}) => {
  const {id, img, name} = entity;

  let entities_img;
  if(img === undefined || img === null){
    entities_img = <span className="c-entities_img-replace">{name[0].toUpperCase()}</span>
  }else{
    entities_img = <img alt="" className="c-entities_img" style={{width: "50px", height: "50px"}} src={img} />
  }


  const checked = entities.includes(entity.id);

  function toggle() {
    if (checked) {
      setEntities(entities.filter(id => id !== entity.id));
    } else {
      setEntities([...entities, entity.id]);
    }
  }

  return (
    <div className={`c-entities ${id}`} onClick={toggle}>
      <div className="c-entities_infos">
          {entities_img}
          <div className="c-infos">
            <p>{name}</p>
          </div>
      </div>
      <input type="checkbox" className="c-entities_checkbox" name="entities" checked={checked} onChange={noop} />
    </div>
  )
}

// theme is in fact, whole themes
// themes is selected_themes
const ThemeItem = ({theme, themes, setThemes}) => {


  function toggle(item, checked) {
    if (checked) {
      setThemes(themes.filter(({id}) => id !== item.id));
    } else {
      setThemes([...themes, item]);
    }
  }

  return (
    <>
      {
        theme.map(t => {
          const checked = themes.some(({id}) => id == t.id);
          return (
            <div key={t.id} className={`c-themes ${t.id}`} onClick={() => toggle(t, checked)}>
              <div className="c-themes_infos">
		  <div className="lock-icon-focus" style={t.confidential ? {} : {visibility: "hidden"}} />
                  <div className="c-infos">
                    <p>{t.item}</p>
                  </div>
              </div>
              <input type="checkbox" className="c-themes_checkbox" name="themes" checked={checked} onChange={noop} />
            </div>
          )
        })
      }
    </>
  )
}

const GeoItem = ({geos, geo, setGeo}) => {
  function toggle(item, checked) {
    setGeo(checked ? null : item);
  }

  return (
    <>
      {
        geos.map(g => {
          const checked = geo === g;

          return (
            <div key={g.id} className={`c-geo ${g.id}`} onClick={() => toggle(g, checked)}>
              <div className="c-geo_infos">
                  <div className="c-infos">
                    <p>{g.item}</p>
                  </div>
              </div>
              <input type="radio" className="c-geo_radio" name="geo" checked={checked} onChange={noop} />
            </div>
          )
        })
      }
    </>
  )
}


export default SelectPopup
